import React from "react";
import { CustomCardFooter } from "@components/Common/CustomCardStyled";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { useTranslation } from "react-i18next";

type ApplicationFooterProps = {
    onCancel: () => void;
    onValidate: () => void;
    isValidateButtonClicked: boolean;
};

export const ApplicationFooter: React.FC<ApplicationFooterProps> = ({
    onCancel,
    onValidate,
    isValidateButtonClicked,
}) => {
    const { t } = useTranslation();

    return (
        <CustomCardFooter className="pt-1 pb-2">
            <CustomSecondaryColorButton
                outline
                rounded
                variant="light"
                className="mr-2 afa_btn_FRcancel cmn_btn_cancel"
                onClick={onCancel}
            >
                <span> {t("Cancel")}</span>
            </CustomSecondaryColorButton>
            <CustomMainColorButton
                rounded
                className="cmn_btn_validate"
                disabled={!isValidateButtonClicked}
                variant="primary"
                onClick={onValidate}
            >
                {t("Validate")}
            </CustomMainColorButton>
        </CustomCardFooter>
    );
};
